import React, { useState } from 'react';
import { connect } from 'react-redux';
import * as MDICONS from '@material-ui/icons';
import maplessCard from '../../assets/hintarts/mapless_card.png'
import maplessTagCreationAnimation from '../../assets/hintarts/new_tag_mapless.gif';

function MaplessGuide(props) {
    const { modalTitleStyle, modalImpInfoTextStyle, modalInfoTextStyle, formLabelStyle } = props;
    const [openCardToggleOne, setOpenCardToggleOne] = useState(true);
    const [openCardToggleTwo, setOpenCardToggleTwo] = useState(true);

    const cardToggle = (num) => {
        switch (num) {
            case 0: {
                setOpenCardToggleOne(!openCardToggleOne);
                break;
            }
            case 1: {
                setOpenCardToggleTwo(!openCardToggleTwo);
                break;
            }
            default: {

            }

        }

    }
    return (
        <div className="dynamicModalContainer">
            <div className="dynamicModalSm">
                <div className="px-3">
                    <p style={modalTitleStyle}>Instant help?</p>
                    <p style={{ fontSize: "14px" }}>Common help guides that would help you record effectively. Reopen this by clicking the 'question mark' on top right.</p>


                    {/* Record tag*/}
                    <div className="card p-2" data-toggle="collapse" href="#collapse1" role="button" aria-expanded="true" aria-controls="collapse1">
                        <div className="d-flex justify-content-between">
                            <p className="" style={formLabelStyle}>Record a tag</p>
                            <button className="btn btn-sm" onClick={() => { cardToggle(0) }}>
                                {openCardToggleOne ? <div><MDICONS.KeyboardArrowUp style={{ scale: "1.5" }} /></div> : <div><MDICONS.KeyboardArrowDown style={{ scale: "1.5" }} /></div>}
                            </button>
                        </div>

                        <div className="collapse show" id="collapse1">
                            <div className="" style={{ border: 'none', margin: '0px' }}>
                                <p style={{ fontSize: '14px' }}>
                                    To add a marker, you will first need to click the add button to place a new tag. Fill the required details and press any positive button (such as submit) to confirm.
                                    <div className="d-flex justify-content-center"><img src={maplessTagCreationAnimation} alt="gif" width="300px" height="200px" /></div>
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Status color */}
                    <div className="card mt-2 p-2" data-toggle="collapse" href="#collapse2" role="button" aria-expanded="true" aria-controls="collapse2">
                        <div className="d-flex justify-content-between">
                            <p className="" style={formLabelStyle}>Status colors</p>
                            <button className="btn btn-sm" onClick={() => { cardToggle(1) }}>
                                {openCardToggleTwo ? <div><MDICONS.KeyboardArrowUp style={{ scale: "1.5" }} /></div> : <div><MDICONS.KeyboardArrowDown style={{ scale: "1.5" }} /></div>}
                            </button>
                        </div>

                        <div class="collapse show" id="collapse2">
                            <div class="" style={{ border: 'none' }}>
                                <div className="d-flex justify-content-center"><img src={maplessCard} alt="gif" width="500px" height="100px" /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    // console.log(state.firebase.data.Company)
    return {
        themeColors: state.theme,
        modalWidth: state.appControl.modalWidthMedium,
        modalHeight: state.appControl.modalHeightMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
        modalImpInfoTextStyle: state.appControl.modalImpInfoTextStyle,
        formLabelStyle: state.appControl.formLabelStyle,
    }
}

export default connect(mapStateToProps)(MaplessGuide);
